import React from "react";

const BS5_Navs = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Navs Component</h2>
      <p>This is the BS5_Navs component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Navs;
